import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
    unseen: 0,
    total: 0,
    notifications: []
};

const setNotifications = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
    };
};

const HANDLERS = {
    [Types.SET_NOTIFICATIONS]: setNotifications
};

export default createReducer(INITIAL_STATE, HANDLERS);